export function resolveSlug(
  pathname: string,
  slugs: readonly string[]
): string | null {
  const path =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname
  if (path === '/' || path === '/terminal') return 'overview'
  const prefix = '/terminal/'
  if (!path.startsWith(prefix)) return null
  const slug = path.slice(prefix.length)
  if (!slugs.includes(slug)) return null
  return slug
}
